/** 연간시간표 '토요일 보기' 설정(워크스페이스별) — localStorage 유지 */

function key(workspaceId: string): string {
  return `cp.annualShowSaturday.v1.${workspaceId}`;
}

export function loadAnnualShowSaturday(workspaceId: string): boolean {
  if (!workspaceId) return false;
  try {
    return window.localStorage.getItem(key(workspaceId)) === '1';
  } catch {
    return false;
  }
}

export function saveAnnualShowSaturday(workspaceId: string, value: boolean): void {
  if (!workspaceId) return;
  try {
    window.localStorage.setItem(key(workspaceId), value ? '1' : '0');
  } catch {
    /* ignore quota */
  }
}
